/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Represents a status
 */
export enum FinnairCompletionStatus {
  COMPLETED = 'COMPLETED',
  INCOMPLETE = 'INCOMPLETE'
}

